import React from 'react'
import Link from 'next/link'

import { Button } from 'components/Common'
import AuthTemplate from '../AuthTemplate'

import styles from './styles'

export const WelcomeComponent = () => {
  return (
    <AuthTemplate style={styles.authTemplate}>
      <div style={styles.header}>Welcome</div>
      <Link href="/auth/sign-in">
        <Button style={styles.button}>Sign In</Button>
      </Link>
    </AuthTemplate>
  )
}
